module.exports = __webpack_public_path__ + "img/bullet_1.96d0880d.svg";